export default {
  mai_mult_label: 'Mai mult',
  mai_incarca_label: 'Mai incarca',
  publicat_label: 'Publicat la'
}
